import * as React from "react"
const SplitPeakIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 300 300"
    {...props}
  >
    <path
      fill="#f39752"
      d="M168.832 283.854V161.779l-5.17-42.15 21.075-41.354 20.678-7.157 8.35 14.315 26.244 95.433 23.46 74.756 14.316 28.232-6.76 1.988"
    />
    <path
      fill="none"
      stroke="#ed1f1f"
      strokeLinecap="round"
      strokeWidth={6}
      d="M155.988 123.95c.194 14.667 3.052 79.902 3.052 93.22"
      transform="matrix(1.69364 0 0 1.69364 -100.525 -83.955)"
    />
    <path
      fill="none"
      stroke="#717171"
      strokeLinecap="round"
      strokeWidth={6}
      d="M67.037 223.015q29.462-19.894 38.21-64.827c8.748-44.933 14.584-94.625 30.183-94.625 11.63 0 15.178 27.744 20.558 60.387"
      transform="matrix(1.69364 0 0 1.69364 -101.272 -87.049)"
    />
    <path
      fill="none"
      stroke="#717171"
      strokeLinecap="round"
      strokeWidth={6}
      d="M116.282 120.978c5.93-5.96 7.513-33.104 20.66-33.104s26.296 97.2 46.722 125.608"
      transform="matrix(1.69364 0 0 1.69364 -33.276 -77.708)"
    />
  </svg>
)
export default SplitPeakIcon
